<template>
  <content-with-loading-skeleton
    :isLoading="isLoading"
    loadingMessage="Loading Live Stream Data..."
    :isWithMessage="true"
  >
    <template #loaded>
      <TopBar />
      <PageSection>
        <!-- Section To Add Live Stream Basic Fields To  -->
        <BindingFields v-model="data.sideFeatureBindingOptions" />
      </PageSection>
      <PageSection>
        <PlayersFilters v-model="data.filters" />
      </PageSection>
      <FloatingFooterButtons>
        <div class="flex flex-row-reverse gap-2">
          <SaveSubscriptionButton ref="saveSubscriptionButtonRef" />
          <ExitButton
            v-bind="{hasUnsavedChanges, unsetHasUnsavedChanges}"
            @exit="onExit"
            @saveAndExit="onSaveAndExit"
          />
        </div>
      </FloatingFooterButtons>
    </template>
  </content-with-loading-skeleton>
</template>


<script setup lang="ts">
import PageSection from '@/components/layouts/PageSection.vue';
import TopBar from './TopBar/TopBar.vue';
import { onBeforeMount, watch }  from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import FloatingFooterButtons from '@/components/layouts/FloatingFooterButtons.vue';
import SaveSubscriptionButton from './SaveSubscriptionButton/SaveSubscriptionButton.vue';
import ExitButton from '@/components/Dialog/ButtonsWithDialog/ExitButton/ExitButton.vue';
import sharedRefs from './sharedRefs';
import router from '@/router';
import PlayersFilters from './PlayersFilters/PlayersFilters.vue';

import { useLiveStream } from './composables/liveStream';
import BindingFields from './BindingFields.vue';
const {
  data, 
  loadPlayerSubscription,
  initializeHasUnsavedChangesWatcher,
  hasUnsavedChanges,
  unsetHasUnsavedChanges,
  isLoading,
} = useLiveStream();
initializeHasUnsavedChangesWatcher();

const route = useRoute()

const currentSubscriptionId = route.params.id;
const { saveSubscriptionButtonRef } = sharedRefs;

function onExit() {
  router.push({ path: '/live-streams' })
}

async function onSaveAndExit() {
  await saveSubscriptionButtonRef.value.saveLiveStream();
  router.push({ path: '/live-streams' })
}

onBeforeMount(async () => {
  await loadPlayerSubscription(Number(currentSubscriptionId));
});

onBeforeRouteUpdate(async (newRoute) => {
  if(newRoute.name === "live-stream-editor") {
    const newLiveStreamId = newRoute.params.id;
    await loadPlayerSubscription(Number(newLiveStreamId));
  }
})
</script>



<style lang="scss" scoped>
.sub-title {
  font-size: 1.5em;
  font-weight: bold;

  @include theme-old {
    color: #252949;
  }

  @include theme-new {
    color: #252949;
  }

  letter-spacing: 2px;
}
</style>
